import { api } from './client';

export interface AdminStats {
  pending_vip: number;
  pending_indicator: number;
  total_members: number;
  new_today?: number;
  new_this_month?: number;
  daily?: { date: string; count: number }[];
  monthly?: { month: string; count: number }[];
  referral?: { source: string; count: number }[];
}

export interface ActivityLog {
  id: string;
  actor_name: string;
  actor_email: string;
  action: string;
  entity_type: string;
  entity_id: string;
  description: string;
  created_at: string;
}

export async function fetchActivityLogs(): Promise<ActivityLog[]> {
  const { data } = await api.get<ActivityLog[]>('/admin/activity-logs');
  return data;
}

export async function fetchAdminStats(): Promise<AdminStats> {
  const { data } = await api.get<AdminStats>('/admin/stats');
  return data;
}
